// src/pages/Login.jsx
import { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";  // 👈 importa useLocation
import { useAuth } from "../auth/AuthContext";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const { login } = useAuth();
  const nav = useNavigate();
  const location = useLocation();                              // 👈 obtén la ruta origen
  const from = location.state?.from?.pathname || "/";          // 👈 define 'from'

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email.trim(), password);
      //nav(from, { replace: true });                            // 👈 ahora sí existe 'from'
      nav("/leads", { replace: true });   // ✅ SIEMPRE va a /leads
    } catch (e) {
      alert(e?.response?.data?.error || "Credenciales inválidas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-title" style={{ maxWidth: 420, margin: "24px auto" }}>
      <h2 style={{ marginTop: 0 }}>Ingresar</h2>
      <form onSubmit={onSubmit} className="card section" style={{ display: "grid", gap: 12 }}>
        <label>
          <div>Email</div>
          <input
            className="input"
            type="email"
            autoComplete="username"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
        </label>
        <label>
          <div>Contraseña</div>
          <input
            className="input"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
        </label>
        <button className="btn btn-primary" disabled={loading}>
          {loading ? "Entrando..." : "Entrar"}
        </button>
      </form>
    </div>
  );
}
